import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/_auth/settings/")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const { hasPagePermission } = useUser();
  const firstAccessiblePath = [
    [PAGE_PERMISSION_KEYS.firmMyFirm, "/settings/firm"],
    [PAGE_PERMISSION_KEYS.firmFiles, "/settings/files"],
    [PAGE_PERMISSION_KEYS.firmTemplates, "/settings/templates"],
    [PAGE_PERMISSION_KEYS.firmSettingsUsers, "/settings/users"],
    [PAGE_PERMISSION_KEYS.firmSettingsPhoneNumbers, "/settings/communication"],
    [PAGE_PERMISSION_KEYS.intakeSettings, "/settings/intake"],
    [PAGE_PERMISSION_KEYS.contactsSettingsTags, "/settings/contact"],
    [PAGE_PERMISSION_KEYS.mattersSettings, "/matters/settings"],
  ].find(([permissionId]) => hasPagePermission(permissionId))?.[1];

  useEffect(() => {
    if (firstAccessiblePath) {
      void navigate({ to: firstAccessiblePath, replace: true });
    }
  }, [firstAccessiblePath, navigate]);

  if (!firstAccessiblePath) {
    return <GlobalNotAuthorized />;
  }

  return null;
}
